<template>
  <p class="fighter-class">{{fighterClass}}</p>
</template>

<script>
export default {
  name: 'FighterClass',
  props: ['fighterClass']
}

</script>

<style lang="scss">
  .fighter-class {
    color: $yellow;
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
    &.profile {
      margin-bottom: 16px;
    }
    @include bp($bp--m) {
      font-size: 24px;
      &.profile {
        margin-bottom: 25px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ui/fighters/FighterClass.vue